/* eslint-disable @typescript-eslint/ban-ts-comment */
import MiiaFwConfig from '@/configs/config'
import { getUserAttributesFromStore } from '../miiaFw/MiiaFwCognito'
import { useHoldTemporaryStore } from '@/stores/holdTemporaryStore'
import { useDisasterStore } from '@/stores/disasterStore'
import { useMiiaFwStore } from '@/stores/miiaFwStore'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { EMERGENCY_SCOPE, ACTION_TYPE } from '@/constants/router/auth'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { storeToRefs } from 'pinia'

/**
 * 有効な災害か
 * @param なし
 * @returns boolean
 */
export const isEnableDisasterUser = (): boolean => {
  const miiaFwStore = useMiiaFwStore()
  const attributes = miiaFwStore.attributes
  if (attributes == undefined) {
    return false
  }

  const disastersStore = useDisasterStore()
  const enableDisaster = disastersStore.disaster
  if (enableDisaster == undefined) {
    // 有効な災害が存在しない
    return false
  }
  const userDisasterId =
    // @ts-ignore
    attributes.attribute[MiiaFwConfig.config.disasterEmergency.commonAttr].disasterId
  if (userDisasterId == undefined) {
    // 自庁職員の場合、災害IDが設定されていないため有効な災害があれば正常
    return true
  }

  // 応援職員の場合、設定されている災害IDと有効な災害の災害IDが一致しているか確認
  return userDisasterId === enableDisaster.disasterId
}

/**
 * ログイン可能な権限か
 * @param なし
 * @returns Promise<boolean>
 */
export const canLogin = async (): Promise<boolean> => {
  const attributes = await getUserAttributesFromStore()
  if (attributes === undefined) {
    // アカウント情報未取得
    return false
  }

  // アカウント情報チェック
  const authority = attributes.attribute[MiiaFwConfig.config.sysId].authority
  if (authority === undefined || authority.length === 0) {
    return false
  }

  // 災害チェック
  const param = {
    system: MiiaFwConfig.config.sysId,
    govCode: attributes.attribute[MiiaFwConfig.config.disasterEmergency.commonAttr].govCode
  }
  const disastersStore = useDisasterStore()
  return await disastersStore
    .fetchAndSetDisasters(param)
    .then(() => {
      return isEnableDisasterUser()
    })
    .catch(() => {
      return false
    })
}

/**
 * デバイス認証がされているか
 * @param なし
 * @returns boolean
 */
export const hasDeviceAuth = (): boolean => {
  const holdTemporaryStore = useHoldTemporaryStore()
  const deviceAuthFlag = holdTemporaryStore.deviceAuthFlag
  if (deviceAuthFlag === undefined) {
    // デバイス未認証
    return false
  }
  return deviceAuthFlag
}

/**
 * 認可を確認し、stateに反映
 */
export const checkAuthority = (): void => {
  const miiaFwStore = useMiiaFwStore()
  const { emergencyAuthority } = storeToRefs(miiaFwStore)
  const permitted = emergencyAuthority.value?.some(
    auth =>
      auth.scope === EMERGENCY_SCOPE.riskAssessment &&
      [ACTION_TYPE.manage, ACTION_TYPE.write, ACTION_TYPE.read].some(action =>
        auth.actions.includes(action)
      )
  )
  if (!permitted) {
    throw new GlobalError([ERROR_CODES.LOGIN_AUTHZ_DENIED])
  }
  miiaFwStore.updateIsPermitted(true)
}
